import { useRequest, useParams, Helmet } from 'umi';
import React, { useState, useEffect } from 'react';
import styles from '../css/dynamicCSS.less';
import cx from 'classnames';
import { CommentsType } from '@/types/camp/dynamic/commentsType';
import { getCommentsList } from '@/utils/requests/camp/requests_dynamic';
import { Button, Image, Space } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import CommentForm from './commentForm';

interface Props {
  replyId: string;
  printIndex: number;
  postReplyCommentsRequest: (value: any) => void;
  isReplyOn: boolean;
}
const CommentsList: React.FC<Props> = ({
  replyId,
  printIndex,
  postReplyCommentsRequest,
  isReplyOn,
}) => {
  const [list, setList] = useState<CommentsType[]>([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [isOn, setIsOn] = useState<boolean>(false);
  const [openIndex, setOpenIndex] = useState<number>();

  useEffect(() => {
    setIsOn(false);
  }, [isReplyOn]);

  const toggleSwitch = (index: number) => {
    if (openIndex === index) {
      setIsOn(!isOn);
    } else {
      setIsOn(true);
    }
  };

  interface PostCommentsType {
    replyId: string;
    content: string;
    image?: string;
    toUid?: number;
  }

  // 列举评论
  const { run: getCommentsListRequest } = useRequest(
    (replyId) => {
      return getCommentsList(replyId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setList(res);
      },
    },
  );

  useEffect(() => {
    getCommentsListRequest(replyId);
  }, [replyId]);

  const handlePreview = (url: any) => {
    setPreviewVisible(true);
    setPreviewImage(url);
  };

  return (
    <>
      <div key={printIndex} className={styles.comments_item_box}>
        {list.map((item, index) => (
          <div key={index}>
            <div
              className={cx(styles.comments_item_box_item, 'flex_1')}
              onClick={() => {
                toggleSwitch(index), setOpenIndex(index);
              }}
            >
              <div className="col008">{item.username}</div>
              <div className="col172">
                {item.toUid ? (
                  <span>
                    <span className={cx(styles.reply_text, 'col595')}>回复</span>
                    <span className="col008">{item.toUsername}：</span>
                  </span>
                ) : (
                  '：'
                )}
              </div>
              <div className="col595">{item.content}</div>
              {item.image && (
                <div className="col595">
                  <Button onClick={() => handlePreview(item.image)} type="link" size={'small'}>
                    <Space size={4}>
                      <span>
                        <PictureOutlined />
                      </span>
                      <span>图片</span>
                    </Space>
                  </Button>
                  <Image
                    key={index}
                    style={{ display: 'none' }}
                    preview={{
                      visible: previewVisible,
                      onVisibleChange: (visible) => setPreviewVisible(visible),
                      getContainer: false,
                    }}
                    src={previewImage}
                  />
                </div>
              )}
            </div>
            {openIndex === index && isOn && (
              <div>
                <CommentForm
                  key={item.id}
                  onSubmit={(values) => {
                    const submitValue: PostCommentsType = {
                      replyId: item.replyId,
                      content: values.content,
                      image: values.imageUrl,
                      toUid: item.createdBy,
                    };
                    submitValue && postReplyCommentsRequest(submitValue);
                  }}
                  toUserName={item.username}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};
export default CommentsList;
